/* eslint-disable camelcase */
import React, { useState } from "react";
import { useTranslation } from "ceco-polyglot";
import { ChevronDown } from "ceicons";
import { format, parseISO } from "date-fns";
import graphql from "babel-plugin-relay/macro";
import { createFragmentContainer } from "react-relay";
import classnames from "classnames";
import { Divider, Accordion, Header } from "semantic-ui-react";
import StatusButton from "../../StatusButton";
import "./recipeDetails.scss";
import IngredientsSummaryList from "./IngredientsSummaryList";
import AllergensSummaryList from "./AllergensSummaryList";

function RecipeDetails(props) {
  const { recipe, summaryIngredient, refetchData } = props;
  const [activeAccordion, setActiveAccordion] = useState({
    ingredients: false,
    allergens: false,
  });

  const t = useTranslation();

  const panels = [
    {
      key: `ingredients`,
      title: (
        <Accordion.Title
          content={t("title.ingredients")}
          onClick={() =>
            setActiveAccordion({
              ...activeAccordion,
              ingredients: !activeAccordion.ingredients,
            })
          }
          icon={
            <ChevronDown
              className={classnames({
                active: activeAccordion.ingredients === true,
              })}
            />
          }
        />
      ),
      content: (
        <Accordion.Content>
          <IngredientsSummaryList summaryIngredient={summaryIngredient} />
        </Accordion.Content>
      ),
    },
    {
      key: `allergens`,
      title: (
        <Accordion.Title
          content={t("title.allergens")}
          onClick={() =>
            setActiveAccordion({
              ...activeAccordion,
              allergens: !activeAccordion.allergens,
            })
          }
          icon={
            <ChevronDown
              className={classnames({
                active: activeAccordion.allergens === true,
              })}
            />
          }
        />
      ),
      content: (
        <Accordion.Content>
          <AllergensSummaryList allergens={recipe.allergen.edges} />
        </Accordion.Content>
      ),
    },
  ];

  return (
    <div className="recipe-details">
      <div className="head-top">
        <StatusButton
          idRecipe={recipe.id}
          status={recipe.published}
          floated="right"
          refetchData={refetchData}
        />
        <Header>{t("header.details")} </Header>
      </div>

      <Divider />

      <div className="info-recipe-creator">
        <span className="item">
          <span className="bold">{t("header.createdBy")}: </span>
          {recipe.author.username}
        </span>
        <span className="item">
          <span className="bold">{t("header.publishDate")}: </span>
          {recipe.publicDate
            ? format(parseISO(recipe.publicDate), "dd-MM-yyyy HH:mm:ss")
            : t("header.notPublished")}
        </span>
      </div>

      <Divider />

      <Accordion panels={panels} exclusive={false} fluid />
    </div>
  );
}
export default createFragmentContainer(RecipeDetails, {
  recipe: graphql`
    fragment RecipeDetails_recipe on RecipeNode {
      id
      published
      publicDate
      author {
        username
      }
      allergen {
        edges {
          node {
            id
            name
            icon
          }
        }
      }
    }
  `,
});
